var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pa-2"},_vm._l((_setup.cards),function(card,i){return _c(_setup.EpiSuiteCard,{key:i,staticClass:"mb-6",attrs:{"item":card,"elevation":_setup.props.cardElevation}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }